import React from 'react';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  InitialDataSelector,
  ShowResetButtonsSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { setShowFitAssistant } from '../../Slices/FitAssistantSlice.ts';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import { trackOK } from '../../Analytics/Adobe.ts';

const OtherFits = () => {
  const dispatch = useAppDispatch();
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStep = useAppSelector(CurrentStepSelector);
  const currentStepContent = useAppSelector(CurrentStepContentSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const translations = useAppSelector(TranslationsSelector);
  const showResetButtons = useAppSelector(ShowResetButtonsSelector);

  const onClickPrimary = () => {
    window.location.href = initialData.ParentPageLink;
  };

  const onClickSecondary = () => {
    if (showResetButtons) {
      dispatch(resetFitAssistant(false));
    } else {
      dispatch(setShowFitAssistant(false));

      trackOK(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation);
    }
  };

  return (
    <>
      <div>
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: currentStepContent?.Text ?? '',
          }}
        />
        {currentStepContent?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100">
            <img src={currentStepContent?.ImageUrl} alt={currentStepContent?.ImageAlt} />
          </div>
        )}
      </div>
      <Buttons visible>
        <PrimaryButton visible text={translations.exploreAlternatives} onClick={onClickPrimary} />
        <SecondaryButton
          visible
          text={showResetButtons ? translations.reset : translations.close}
          onClick={onClickSecondary}
        />
      </Buttons>
    </>
  );
};

export default OtherFits;
